<!-- <nz-tree-select [nzCheckable]="true" [nzNodes]="treeNodes$ | async" [ngModel]="keys$ | async" [nzCheckStrictly]="true" (nzTreeCheckBoxChange)="checkChange($event)"
    (ngModelChange)="modelChange($event)">

</nz-tree-select> -->

<nz-tree-view [nzTreeControl]="treeControl" [nzDataSource]="dataSource">
    <nz-tree-node *nzTreeNodeDef="let node" nzTreeNodePadding>
        <nz-tree-node-toggle nzTreeNodeNoopToggle></nz-tree-node-toggle>
        <nz-tree-node-checkbox [nzDisabled]="node.disabled" [nzChecked]="checklistSelection.isSelected(node)"
            (nzClick)="leafItemSelectionToggle(node)"></nz-tree-node-checkbox>
        <nz-tree-node-option [nzDisabled]="node.disabled" (nzClick)="leafItemSelectionToggle(node)">
            {{ node.name }}
        </nz-tree-node-option>
    </nz-tree-node>

    <nz-tree-node *nzTreeNodeDef="let node; when: hasChild" nzTreeNodePadding>
        <nz-tree-node-toggle>
            <i nz-icon nzType="caret-down" nzTreeNodeToggleRotateIcon></i>
        </nz-tree-node-toggle>
        <nz-tree-node-checkbox [nzDisabled]="node.disabled" [nzChecked]="descendantsAllSelected(node)"
            [nzIndeterminate]="descendantsPartiallySelected(node)" (nzClick)="itemSelectionToggle(node)">
        </nz-tree-node-checkbox>
        <nz-tree-node-option [nzDisabled]="node.disabled" (nzClick)="itemSelectionToggle(node)">
            {{ node.name }}
        </nz-tree-node-option>
    </nz-tree-node>
</nz-tree-view>